import { AwsUi } from '../../../core/runtime/src';
import { render, callbacks } from './common';
export var Toggle = AwsUi.__addComponent('awsui-toggle', {
    releaseStatus: 'stable',
    callbacks: callbacks,
    properties: {
        // Specifies whether the component is checked.
        checked: {
            type: 'boolean'
        },
        // Specifies that the input should be disabled, preventing the user from
        // modifying the value and excluding the value from being included with a
        // form submit. In AngularJS use `data-disabled` instead.
        disabled: {
            type: 'boolean'
        },
        // The id of the internal input. Useful for relating a label element's
        // "for" attribute to this control.
        controlId: {
            type: 'string'
        },
        // The name of the control used in HTML forms.
        name: {
            type: 'string'
        },
        // Adds aria-labelledby on the native input. Use this only with form fields that
        // contain multiple controls under the same label.
        // 1. Define a custom id inside the label
        // 2. Refer to that label from every single control under that label using this property
        ariaLabelledby: {
            type: 'string'
        },
        // Adds aria-describedby on the native input. Use this only with form fields that
        // contain multiple controls under the same label.
        // 1. Define custom ids inside the description, hint and error text
        // 2. Refer to these from every single control under that label using this property
        // 3. Refer to any other hint/description text that you provide
        ariaDescribedby: {
            type: 'string'
        },
        // Adds an `aria-label` to the native input. Only use this when you do not have a
        // visible label for this control.
        ariaLabel: {
            type: 'string'
        }
    },
    events: {
        // Fired when input focus is set onto the UI control.
        focus: {
            bubbles: true,
            cancelable: false
        },
        // Fired when input focus is removed from the UI control.
        blur: {
            bubbles: true,
            cancelable: false
        },
        // Fired when the user changes the component state.
        // The event `detail` contains the current value for the `checked` property.
        change: {
            bubbles: true,
            cancelable: false,
            detailType: 'Toggle.ChangeDetail'
        }
    },
    render: function (m, h) {
        var div = AwsUi.__createElement("div", { className: "awsui-toggle-handle" });
        return render(this, h, div);
    },
    functions: {
        // Sets input focus onto the UI control.
        focus: function () {
            this.node.querySelector('input').focus();
        }
    },
    regions: {
        // Label for the input.
        label: {
            isDefault: true
        },
        // Extra description shown below the label.
        description: {}
    },
    wrapperSupport: {
        ngModel: {
            value: 'checked',
            event: 'change'
        }
    }
});
//# sourceMappingURL=toggle.js.map